import { NextSeo } from 'next-seo';
import React from 'react';
import PageHeader from '../../components/PageHeader';
import TraitShufflePage from '../../components/TraitShufflePage';
import config from '../../config';

function Page() {
  const title = `Trait Shuffle - ${config.siteName}`;
  const description = `Shuffle new traits for your Fourth Litter Shitty Kitties.`;

  return (
    <>
      <NextSeo title={title} description={description} />
      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          heading={'Trait Shuffle'}
          description={description}
          docsLink='https://docs.shittykitties.art/website-utilities/trait-shuffle'
          fullWidth
        />

        <div className='px-4 lg:mx-auto lg:px-8'>
          <TraitShufflePage />
        </div>
      </div>
    </>
  );
}

export default Page;
